<template>
    <div class="height-100">
        <gofix-card title="Completed By" class="fixHeight">
            <template slot="gofixCard:right_header">
                <template v-if="!IsReadOnly">
                    <button
                        v-if="$checkRole(this.$accessModule.order_tabs.main_info, 'update')"
                        class="icon-button" @click="open = true"><img width="20" src="img/iconPencil.png" alt="" /></button>
                </template>
            </template>
            <div class="mb-0 font-size-16" v-if="Item.completed_by">
                <span class="pr-3">{{Item.completed_by.name}}</span>
                <span class="pr-3">{{Item.completed_by.mailing_address && Item.completed_by.mailing_address.primary_phone ? "+" + Item.completed_by.mailing_address.primary_phone : null}}</span>
                <span> {{Item.completed_by.email}}</span>
            </div>
            <b-row v-if="Item.completed_date" class="mt-8">
                <b-col md="12">
                    <gofix-text-field class="mb-3" label="Date" oneline>{{Item.completed_date | formatDatebyMoment('YYYY-MM-DD HH:mm:ss','DD.MM.YYYY')}}</gofix-text-field>
                </b-col>
            </b-row>
        </gofix-card>

        <b-modal 
            :no-close-on-backdrop="true"
            id="modal-CompletedBy"
            title="Completed By"
            hide-footer
            :centered="true"
            ref="modal-Completed"
            @shown="shownModal"
            v-model="open">
            <b-form>
                <gofix-form-dropdown
                    label="Name"
                    vLabel="name"
                    :filterable="false"
                    @search="searchUsers"
                    v-model="data.completed_by"
                    :options="users">
                    <template slot="gofixInput:dropdown:option" slot-scope="option">
                        <span class="color-000">{{ option.name }} - {{option.email}}</span>
                    </template>
                    <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                        <span class="color-000">{{ option.name }} - {{option.email}}</span>
                    </template>
                </gofix-form-dropdown>
                <b-row class="mb-20" v-if="data.completed_by">
                    <b-col md="6">
                        <div class="content">
                            <label class="min-width-0">Email</label> <div class="info-right ordersInput">
                            {{data.completed_by.email}}
                        </div>
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="content">
                            <label class="min-width-0">Phone Number</label> <div class="info-right ordersInput">
                            {{data.completed_by.mailing_address && data.completed_by.mailing_address.primary_phone ? "+" + data.completed_by.mailing_address.primary_phone : null}}
                        </div>
                        </div>
                    </b-col>
                </b-row>
                <gofix-form-input-date
                    v-model="data.completed_date"
                    label="Date completed">
                </gofix-form-input-date>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="saveData" :loading="loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';

    export default {
        name: 'order-completed-by',
        components: {},
        data () {
            return {
                open: false,
                loading:false,
                data:{
                    completed_by : null,
                    completed_date : null,
                },
                users:[],
                timer: null,
            }
        },
        computed: {
            ...mapGetters({
                Item: 'OrderController/Item',
                IsReadOnly: 'OrderController/IsReadOnly',
            }),
        },
        created() {},
        methods: {
            /*--- Get data -----------------------------------------------------------------*/
            async saveData(){
                if(this.loading) return;
                this.loadings = true;

                if(this.data.completed_by == null) {
                    return this.$alertNotification("Please select user!", "warning");
                }
                
                let data = {
                    completed_by_id: this.data.completed_by.id,
                    completed_date: this.data.completed_date != null ? moment(this.data.completed_date).format("YYYY-MM-DD HH:mm:ss") : null ,
                    log:'completed_by'
                };
                this.$store.dispatch("OrderController/updateItem",{ id:this.Item.id, data: data })
                    .then(response => {
                        this.open = false;
                        this.loading = false;
                        this.$alertNotification(this.$notificationV2('editing', 'order'));
                    })
                    .catch(err => {
                        console.log(err);
                        this.loading = false;
                    })
            },

            /*--- Get data -----------------------------------------------------------------*/
            loadUser(limit_item, filters) {
                return new Promise((resolve, reject) => {
                    this.$store.dispatch("v2UserController/searchListUser", { limit: limit_item, page: 1, filters: filters }).
                    then( response => resolve(response) )
                    .catch( () => reject )
                });               
            },
            async searchUsers(search, loading){
                loading(true);
                this.users = [];
                this.loadUser(100, { name: search })
                    .then( response => {
                        this.users = response.data;
                        loading( false );
                    })
                    .catch( reject => {
                        loading(false);
                    })
            },
            /*--- Shown Modals -----------------------------------------------------------------*/
            shownModal(){
                this.data.completed_date = (this.Item.completed_date != null) ? new Date(this.Item.completed_date) : null;
                this.data.completed_by = this.Item.completed_by;
                this.loadUser(100, null)
                    .then( response => {
                        this.users = response.data;
                    })
                    .catch( reject => {
                        console.log(reject);
                    })
            }
        }
    }
</script>